import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

// import colors from "constants/palette";
import { getThemeState } from "state/selector";
// import Fetch from "components/Fetch";
// import Button from "components/buttons/Button";
import Search from "components/inputs/Search";
import Select, { Cascader } from "components/inputs/Select";
import Loading from "components/App/Loading";

function Index({ data, setProducts }) {
  // console.log("dashboard/index/filters products", products);
  const { search } = useLocation();

  const [category, setCategory] = useState("همه");
  const [brand, setBrand] = useState("همه");
  const [order, setOrder] = useState("جدیدترین");

  useEffect(() => {
    var newProducts = data.products;

    if (category !== "همه") {
      newProducts = newProducts.filter((item) => item.category === category);
    }
    if (brand !== "همه") {
      newProducts = newProducts.filter((item) => item.brand === brand);
    }

    const param = search.split("?")?.[1];
    if (param) {
      if (param === "is_off") {
        newProducts = newProducts.filter((item) => item.isOff);
        setOrder(orderOptions[4]);
      }

      if (param === "no_stock") {
        newProducts = newProducts.filter((item) => !item.stock);

        setOrder(orderOptions[5]);
      }
    }

    setProducts(newProducts);
    // if (category) {
    //   setProducts(products.filter((item) => item.category === category))
    // }
  }, [category, brand, order, search, data.products, setProducts]);

  function handleSearch({ target }) {
    const { value } = target;
    var newProducts = data.products;
    if (value) {
      newProducts = newProducts.filter(
        (item) => item.title.includes(value) && item
      );
    }
    setProducts(newProducts);
  }
  function handleOrder(value) {
    var newProducts = [...data.products];

    // console.log(value);
    if (value === orderOptions[0].title) {
      // newest : do nothing with data.products
      setProducts([]);
      newProducts = [...data.products?.reverse()];
    }
    if (value === orderOptions[1].title) {
      // oldest :

      newProducts = [...data.products?.reverse()];
    }
    if (value === orderOptions[2].title) {
      // most :
      newProducts.sort((a, b) => a.stock - b.stock)?.reverse();
    }
    if (value === orderOptions[3].title) {
      // least :
      newProducts.sort((a, b) => a.stock - b.stock);
    }
    if (value === orderOptions[4].title) {
      // is_off :
      let temp = newProducts.filter((e) => e.isOff);
      newProducts = temp;
    }
    if (value === orderOptions[5].title) {
      // no_stock :
      let temp = newProducts.filter((e) => !e.stock);
      console.log(temp);

      newProducts = temp;
      console.log(newProducts);
    }
    setProducts([...newProducts]);
  }

  if (!data) {
    return <Loading />;
  }
  return (
    <FiltersContainer>
      <Search placeholder="جستجو..." onChange={handleSearch} />
      <Cascader
        placeholder="دسته بندی"
        options={[{ value: "همه", label: "همه" }, ...data.sortedCategories]}
        showSearch={{ filter: searchFilter }}
        optionFilterProp="children"
        onChange={(value) => setCategory(value.join("-"))}
        allowClear={false}
        style={{ marginRight: 12 }}
      />
      <Select
        list={[{ title: "همه" }, ...data.brands]}
        defaultValue={null}
        style={{ marginRight: 12 }}
        showSearch
        placeholder="برند"
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        filterSort={(optionA, optionB) =>
          optionA.children
            .toLowerCase()
            .localeCompare(optionB.children.toLowerCase())
        }
        onChange={(value, object) => setBrand(value)}
      />
      <Select
        list={orderOptions}
        style={{ marginRight: 12 }}
        onChange={handleOrder}
        defaultValue={
          search.split("?")?.[1]
            ? orderOptions[
                orderOptions.findIndex((e) => e.key === search.split("?")?.[1])
              ].title
            : orderOptions[1].title
        }
      />
    </FiltersContainer>
  );
}
const mapStateToProps = (state) => {
  const theme = getThemeState(state);
  return { theme };
};
export default connect(mapStateToProps)(Index);

const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;

  & .ant-select-selector {
    border-radius: 24px !important;
  }
`;
const orderOptions = [
  {
    title: "جدیدترین",
  },
  {
    title: "قدیمی ترین",
  },
  {
    title: "بیشترین تعداد",
  },
  {
    title: "کمترین تعداد",
  },
  {
    title: "تخفیف دار",
    key: "is_off",
  },
  {
    title: "بدون موجودی",
    key: "no_stock",
  },
];
const searchFilter = (inputValue, path) =>
  path.some(
    (option) =>
      option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
